import React from 'react'
import Breadcrumb from '../common/Breadcrumb'

const VisionMission = () => {
  return (
    <>
       <Breadcrumb 
            pageTitle="Vision & Mission"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "Vision & Mission" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />
       <section class="space-ptb">
      <div class="container">
        <div className='row'>
            <div className='col-md-12'>
                <h2 class="title text-center mb-4"><span class="text-primary"> Vision & Mission</span></h2>
                <div className="curved-line mx-auto mt-3"></div>
          
            </div>

        </div>
        <div class="row align-items-center">          
          <div class="col-lg-8 mb-4 mb-lg-0">
            <div class="section-title mb-4">
              <h3 class="title  text-start"><span class="text-primary">OUR VISION</span></h3>
                <p class="lead mb-0">
                    The strength for following the dreams comes from our six decades of rich experience, pride of producing achievers and motivation of utilising education as means to transform the society.In these days when strong winds of erosive culture are sweeping pillars of our moral and social values, P.M.S. lends strength to social and family fabric by blending the right values in education. We believe that we must adopt what is good in other cultures but should not be swept off our feet.
                </p>
            </div>            
          </div>
          <div class="col-lg-4">
            <div class="row">
              <div class="col-sm-12">
                <img class="img-fluid w-100 border-radius" src="/images/vision.png" alt="" />
              </div>              
            </div>
          </div>
        </div>

        <div class="row align-items-center pt-5">  
          <div class="col-lg-4  d-none d-lg-block">
            <div class="row">
              <div class="col-sm-12">
                <img class="img-fluid w-100 border-radius" src="/images/mission.png" alt="" />
              </div>             
            </div>
          </div>

          <div class="col-lg-8 mb-4 mb-lg-0">
            <div class="section-title mb-4">
              <h3 class="title  text-start"><span class="text-primary">OUR MISSION</span></h3>
                <p class="lead mb-0">
                    Our Mission: The P.M.S. has been a true pioneer in providing quality education and has stood as a lighthouse. Led by Prof. Puran Singh as its guiding beacon, our strength is our motivation, our qualified and dedicated staff and the support of our conscious and co-operative guardians. Share your dream for your child with us, we shall help you to realise that together.In these days when strong winds of erosive culture are sweeping pillars of our moral and social values, P.M.S. lends strength to social and family fabric by blending the right values in education. We believe that we must adopt what is good in other cultures but should not be swept off our feet.
                </p>
            </div>            
          </div>

          <div class="col-lg-4 d-block d-lg-none">
            <div class="row">
              <div class="col-sm-12">
                <img class="img-fluid w-100 border-radius" src="/images/mission.png" alt="" />
              </div>             
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  )
}

export default VisionMission
